// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type { PersonalizedUser } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';
import type {
  ChatError_ChatBadData,
  ChatError_ChatDoesNotExist,
  ChatError_ChatIsUnavailable,
  ChatError_DeepLinkBadData,
  ChatError_DeepLinkTaken,
  ChatError_E2eeCommitResyncRequired,
  ChatError_E2eeCommitSyncRequired,
  ChatError_E2eeParticipantMissingWelcome,
  ChatError_HasNoPermissionsToPerformAction,
  ChatError_InvalidChatType,
  ChatError_PinnedChannelsLimit,
  ChatError_PinnedGroupsLimit,
  ChatError_UnsupportedChatType,
  ChatError_UserChatRelationshipDoesNotExist,
  ChatError_UserDoesNotExist,
  ChatError_WrongP2PChat,
} from './chat_errors_pb';
import { file_chat_chat_errors } from './chat_errors_pb';
import type { ChatEvent } from './chat_event_model_pb';
import { file_chat_chat_event_model } from './chat_event_model_pb';
import type {
  ChatParticipant,
  PersonalizedChat,
  SecretChatAccessRequest,
  UserPinnedChats,
} from './chat_model_pb';
import { file_chat_chat_model } from './chat_model_pb';
import type { ChatUpdate } from './chat_update_model_pb';
import { file_chat_chat_update_model } from './chat_update_model_pb';

/**
 * Describes the file chat/chat_responses.proto.
 */
export const file_chat_chat_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_common_common_responses,
      file_chat_chat_event_model,
      file_chat_chat_update_model,
      file_chat_chat_model,
      file_chat_chat_errors,
      file_user_user_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.ChatsPageResponse
 */
export type ChatsPageResponse = Message<'com.gem.bff.contract.ChatsPageResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChatsPageResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsPageSuccess success = 1;
         */
        value: ChatsPageSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChatsPageResponse.
 * Use `create(ChatsPageResponseSchema)` to create a new message.
 */
export const ChatsPageResponseSchema: GenMessage<ChatsPageResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 0);

/**
 * @generated from message com.gem.bff.contract.ChatsPageSuccess
 */
export type ChatsPageSuccess = Message<'com.gem.bff.contract.ChatsPageSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ChatUpdate items = 1;
   */
  items: ChatUpdate[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsPageSuccess.
 * Use `create(ChatsPageSuccessSchema)` to create a new message.
 */
export const ChatsPageSuccessSchema: GenMessage<ChatsPageSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 1);

/**
 * @generated from message com.gem.bff.contract.ChatsUpdatesResponse
 */
export type ChatsUpdatesResponse = Message<'com.gem.bff.contract.ChatsUpdatesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChatsUpdatesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsUpdatesSuccess success = 1;
         */
        value: ChatsUpdatesSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChatsUpdatesResponse.
 * Use `create(ChatsUpdatesResponseSchema)` to create a new message.
 */
export const ChatsUpdatesResponseSchema: GenMessage<ChatsUpdatesResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 2);

/**
 * @generated from message com.gem.bff.contract.ChatsUpdatesSuccess
 */
export type ChatsUpdatesSuccess = Message<'com.gem.bff.contract.ChatsUpdatesSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ChatUpdate items = 1;
   */
  items: ChatUpdate[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsUpdatesSuccess.
 * Use `create(ChatsUpdatesSuccessSchema)` to create a new message.
 */
export const ChatsUpdatesSuccessSchema: GenMessage<ChatsUpdatesSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 3);

/**
 * @generated from message com.gem.bff.contract.ChatsByIdsResponse
 */
export type ChatsByIdsResponse = Message<'com.gem.bff.contract.ChatsByIdsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChatsByIdsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatsByIdsSuccess success = 1;
         */
        value: ChatsByIdsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChatsByIdsResponse.
 * Use `create(ChatsByIdsResponseSchema)` to create a new message.
 */
export const ChatsByIdsResponseSchema: GenMessage<ChatsByIdsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 4);

/**
 * @generated from message com.gem.bff.contract.ChatsByIdsSuccess
 */
export type ChatsByIdsSuccess = Message<'com.gem.bff.contract.ChatsByIdsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.PersonalizedChat items = 1;
   */
  items: PersonalizedChat[];
};

/**
 * Describes the message com.gem.bff.contract.ChatsByIdsSuccess.
 * Use `create(ChatsByIdsSuccessSchema)` to create a new message.
 */
export const ChatsByIdsSuccessSchema: GenMessage<ChatsByIdsSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 5);

/**
 * @generated from message com.gem.bff.contract.ChatResponse
 */
export type ChatResponse = Message<'com.gem.bff.contract.ChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.PersonalizedChat success = 1;
         */
        value: PersonalizedChat;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChatResponse.
 * Use `create(ChatResponseSchema)` to create a new message.
 */
export const ChatResponseSchema: GenMessage<ChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 6);

/**
 * @generated from message com.gem.bff.contract.CreateChatResponse
 */
export type CreateChatResponse = Message<'com.gem.bff.contract.CreateChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateChatSuccess success = 1;
         */
        value: CreateChatSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.InvalidChatType invalidChatType = 2;
         */
        value: ChatError_InvalidChatType;
        case: 'invalidChatType';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.WrongP2PChat wrongP2PChat = 3;
         */
        value: ChatError_WrongP2PChat;
        case: 'wrongP2PChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserDoesNotExist userDoesNotExist = 4;
         */
        value: ChatError_UserDoesNotExist;
        case: 'userDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.DeepLinkTaken deepLinkTaken = 5;
         */
        value: ChatError_DeepLinkTaken;
        case: 'deepLinkTaken';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.DeepLinkBadData deepLinkBadData = 6;
         */
        value: ChatError_DeepLinkBadData;
        case: 'deepLinkBadData';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatBadData chatBadData = 7;
         */
        value: ChatError_ChatBadData;
        case: 'chatBadData';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateChatResponse.
 * Use `create(CreateChatResponseSchema)` to create a new message.
 */
export const CreateChatResponseSchema: GenMessage<CreateChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 7);

/**
 * @generated from message com.gem.bff.contract.CreateSecretChatResponse
 */
export type CreateSecretChatResponse = Message<'com.gem.bff.contract.CreateSecretChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateSecretChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateChatSuccess success = 1;
         */
        value: CreateChatSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserDoesNotExist userDoesNotExist = 2;
         */
        value: ChatError_UserDoesNotExist;
        case: 'userDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatBadData chatBadData = 3;
         */
        value: ChatError_ChatBadData;
        case: 'chatBadData';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome e2eeParticipantMissingWelcome = 4;
         */
        value: ChatError_E2eeParticipantMissingWelcome;
        case: 'e2eeParticipantMissingWelcome';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateSecretChatResponse.
 * Use `create(CreateSecretChatResponseSchema)` to create a new message.
 */
export const CreateSecretChatResponseSchema: GenMessage<CreateSecretChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 8);

/**
 * @generated from message com.gem.bff.contract.CreateChatSuccess
 */
export type CreateChatSuccess = Message<'com.gem.bff.contract.CreateChatSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedChat personalizedChat = 1;
   */
  personalizedChat?: PersonalizedChat;

  /**
   * @generated from field: com.gem.bff.contract.ChatUpdate chatUpdate = 2;
   */
  chatUpdate?: ChatUpdate;
};

/**
 * Describes the message com.gem.bff.contract.CreateChatSuccess.
 * Use `create(CreateChatSuccessSchema)` to create a new message.
 */
export const CreateChatSuccessSchema: GenMessage<CreateChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 9);

/**
 * @generated from message com.gem.bff.contract.CreateSecretChatAccessRequestResponse
 */
export type CreateSecretChatAccessRequestResponse =
  Message<'com.gem.bff.contract.CreateSecretChatAccessRequestResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.CreateSecretChatAccessRequestResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.InvalidChatType invalidChatType = 4;
           */
          value: ChatError_InvalidChatType;
          case: 'invalidChatType';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.CreateSecretChatAccessRequestResponse.
 * Use `create(CreateSecretChatAccessRequestResponseSchema)` to create a new message.
 */
export const CreateSecretChatAccessRequestResponseSchema: GenMessage<CreateSecretChatAccessRequestResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 10);

/**
 * @generated from message com.gem.bff.contract.GetActiveSecretChatAccessRequestsResponse
 */
export type GetActiveSecretChatAccessRequestsResponse =
  Message<'com.gem.bff.contract.GetActiveSecretChatAccessRequestsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetActiveSecretChatAccessRequestsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetActiveSecretChatAccessRequestsSuccess success = 1;
           */
          value: GetActiveSecretChatAccessRequestsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetActiveSecretChatAccessRequestsResponse.
 * Use `create(GetActiveSecretChatAccessRequestsResponseSchema)` to create a new message.
 */
export const GetActiveSecretChatAccessRequestsResponseSchema: GenMessage<GetActiveSecretChatAccessRequestsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 11);

/**
 * @generated from message com.gem.bff.contract.GetActiveSecretChatAccessRequestsSuccess
 */
export type GetActiveSecretChatAccessRequestsSuccess =
  Message<'com.gem.bff.contract.GetActiveSecretChatAccessRequestsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.SecretChatAccessRequest secretChatAccessRequest = 1;
     */
    secretChatAccessRequest: SecretChatAccessRequest[];
  };

/**
 * Describes the message com.gem.bff.contract.GetActiveSecretChatAccessRequestsSuccess.
 * Use `create(GetActiveSecretChatAccessRequestsSuccessSchema)` to create a new message.
 */
export const GetActiveSecretChatAccessRequestsSuccessSchema: GenMessage<GetActiveSecretChatAccessRequestsSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 12);

/**
 * @generated from message com.gem.bff.contract.AcceptSecretChatAccessRequestsResponse
 */
export type AcceptSecretChatAccessRequestsResponse =
  Message<'com.gem.bff.contract.AcceptSecretChatAccessRequestsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.AcceptSecretChatAccessRequestsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitSyncRequired e2eeCommitSyncRequired = 5;
           */
          value: ChatError_E2eeCommitSyncRequired;
          case: 'e2eeCommitSyncRequired';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitResyncRequired e2eeCommitResyncRequired = 6;
           */
          value: ChatError_E2eeCommitResyncRequired;
          case: 'e2eeCommitResyncRequired';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome e2eeParticipantMissingWelcome = 7;
           */
          value: ChatError_E2eeParticipantMissingWelcome;
          case: 'e2eeParticipantMissingWelcome';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.AcceptSecretChatAccessRequestsResponse.
 * Use `create(AcceptSecretChatAccessRequestsResponseSchema)` to create a new message.
 */
export const AcceptSecretChatAccessRequestsResponseSchema: GenMessage<AcceptSecretChatAccessRequestsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 13);

/**
 * @generated from message com.gem.bff.contract.DeclineSecretChatAccessRequestsResponse
 */
export type DeclineSecretChatAccessRequestsResponse =
  Message<'com.gem.bff.contract.DeclineSecretChatAccessRequestsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.DeclineSecretChatAccessRequestsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.DeclineSecretChatAccessRequestsResponse.
 * Use `create(DeclineSecretChatAccessRequestsResponseSchema)` to create a new message.
 */
export const DeclineSecretChatAccessRequestsResponseSchema: GenMessage<DeclineSecretChatAccessRequestsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 14);

/**
 * @generated from message com.gem.bff.contract.UpdateChatResponse
 */
export type UpdateChatResponse = Message<'com.gem.bff.contract.UpdateChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UpdateChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateChatSuccess success = 1;
         */
        value: UpdateChatSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 2;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.InvalidChatType invalidChatType = 3;
         */
        value: ChatError_InvalidChatType;
        case: 'invalidChatType';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UpdateChatResponse.
 * Use `create(UpdateChatResponseSchema)` to create a new message.
 */
export const UpdateChatResponseSchema: GenMessage<UpdateChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 15);

/**
 * @generated from message com.gem.bff.contract.UpdateChatSuccess
 */
export type UpdateChatSuccess = Message<'com.gem.bff.contract.UpdateChatSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedChat item = 1;
   */
  item?: PersonalizedChat;
};

/**
 * Describes the message com.gem.bff.contract.UpdateChatSuccess.
 * Use `create(UpdateChatSuccessSchema)` to create a new message.
 */
export const UpdateChatSuccessSchema: GenMessage<UpdateChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 16);

/**
 * @generated from message com.gem.bff.contract.RemoveChatResponse
 */
export type RemoveChatResponse = Message<'com.gem.bff.contract.RemoveChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RemoveChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 2;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.InvalidChatType invalidChatType = 3;
         */
        value: ChatError_InvalidChatType;
        case: 'invalidChatType';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RemoveChatResponse.
 * Use `create(RemoveChatResponseSchema)` to create a new message.
 */
export const RemoveChatResponseSchema: GenMessage<RemoveChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 17);

/**
 * @generated from message com.gem.bff.contract.JoinChatResponse
 */
export type JoinChatResponse = Message<'com.gem.bff.contract.JoinChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.JoinChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.PersonalizedChat success = 1;
         */
        value: PersonalizedChat;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.JoinChatResponse.
 * Use `create(JoinChatResponseSchema)` to create a new message.
 */
export const JoinChatResponseSchema: GenMessage<JoinChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 18);

/**
 * @generated from message com.gem.bff.contract.AddChatParticipantsResponse
 */
export type AddChatParticipantsResponse =
  Message<'com.gem.bff.contract.AddChatParticipantsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.AddChatParticipantsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserDoesNotExist userDoesNotExist = 6;
           */
          value: ChatError_UserDoesNotExist;
          case: 'userDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.AddChatParticipantsResponse.
 * Use `create(AddChatParticipantsResponseSchema)` to create a new message.
 */
export const AddChatParticipantsResponseSchema: GenMessage<AddChatParticipantsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 19);

/**
 * @generated from message com.gem.bff.contract.AddSecretChatParticipantsResponse
 */
export type AddSecretChatParticipantsResponse =
  Message<'com.gem.bff.contract.AddSecretChatParticipantsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.AddSecretChatParticipantsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserDoesNotExist userDoesNotExist = 6;
           */
          value: ChatError_UserDoesNotExist;
          case: 'userDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitSyncRequired e2eeCommitSyncRequired = 7;
           */
          value: ChatError_E2eeCommitSyncRequired;
          case: 'e2eeCommitSyncRequired';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitResyncRequired e2eeCommitResyncRequired = 8;
           */
          value: ChatError_E2eeCommitResyncRequired;
          case: 'e2eeCommitResyncRequired';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeParticipantMissingWelcome e2eeParticipantMissingWelcome = 9;
           */
          value: ChatError_E2eeParticipantMissingWelcome;
          case: 'e2eeParticipantMissingWelcome';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.AddSecretChatParticipantsResponse.
 * Use `create(AddSecretChatParticipantsResponseSchema)` to create a new message.
 */
export const AddSecretChatParticipantsResponseSchema: GenMessage<AddSecretChatParticipantsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 20);

/**
 * @generated from message com.gem.bff.contract.AddChatAdminsResponse
 */
export type AddChatAdminsResponse = Message<'com.gem.bff.contract.AddChatAdminsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.AddChatAdminsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserDoesNotExist userDoesNotExist = 6;
         */
        value: ChatError_UserDoesNotExist;
        case: 'userDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.AddChatAdminsResponse.
 * Use `create(AddChatAdminsResponseSchema)` to create a new message.
 */
export const AddChatAdminsResponseSchema: GenMessage<AddChatAdminsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 21);

/**
 * @generated from message com.gem.bff.contract.RemoveChatParticipantsResponse
 */
export type RemoveChatParticipantsResponse =
  Message<'com.gem.bff.contract.RemoveChatParticipantsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RemoveChatParticipantsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RemoveChatParticipantsResponse.
 * Use `create(RemoveChatParticipantsResponseSchema)` to create a new message.
 */
export const RemoveChatParticipantsResponseSchema: GenMessage<RemoveChatParticipantsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 22);

/**
 * @generated from message com.gem.bff.contract.RemoveSecretChatParticipantsResponse
 */
export type RemoveSecretChatParticipantsResponse =
  Message<'com.gem.bff.contract.RemoveSecretChatParticipantsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.RemoveSecretChatParticipantsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitSyncRequired e2eeCommitSyncRequired = 6;
           */
          value: ChatError_E2eeCommitSyncRequired;
          case: 'e2eeCommitSyncRequired';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitResyncRequired e2eeCommitResyncRequired = 7;
           */
          value: ChatError_E2eeCommitResyncRequired;
          case: 'e2eeCommitResyncRequired';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.RemoveSecretChatParticipantsResponse.
 * Use `create(RemoveSecretChatParticipantsResponseSchema)` to create a new message.
 */
export const RemoveSecretChatParticipantsResponseSchema: GenMessage<RemoveSecretChatParticipantsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 23);

/**
 * @generated from message com.gem.bff.contract.RevokeChatAdminsResponse
 */
export type RevokeChatAdminsResponse = Message<'com.gem.bff.contract.RevokeChatAdminsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RevokeChatAdminsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RevokeChatAdminsResponse.
 * Use `create(RevokeChatAdminsResponseSchema)` to create a new message.
 */
export const RevokeChatAdminsResponseSchema: GenMessage<RevokeChatAdminsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 24);

/**
 * @generated from message com.gem.bff.contract.TransferOwnershipResponse
 */
export type TransferOwnershipResponse =
  Message<'com.gem.bff.contract.TransferOwnershipResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.TransferOwnershipResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
           */
          value: ChatError_UserChatRelationshipDoesNotExist;
          case: 'userChatRelationshipDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.TransferOwnershipResponse.
 * Use `create(TransferOwnershipResponseSchema)` to create a new message.
 */
export const TransferOwnershipResponseSchema: GenMessage<TransferOwnershipResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 25);

/**
 * @generated from message com.gem.bff.contract.LeaveChatResponse
 */
export type LeaveChatResponse = Message<'com.gem.bff.contract.LeaveChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.LeaveChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.LeaveChatResponse.
 * Use `create(LeaveChatResponseSchema)` to create a new message.
 */
export const LeaveChatResponseSchema: GenMessage<LeaveChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 26);

/**
 * @generated from message com.gem.bff.contract.UnpinAllMessagesResponse
 */
export type UnpinAllMessagesResponse = Message<'com.gem.bff.contract.UnpinAllMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UnpinAllMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UnpinAllMessagesResponse.
 * Use `create(UnpinAllMessagesResponseSchema)` to create a new message.
 */
export const UnpinAllMessagesResponseSchema: GenMessage<UnpinAllMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 27);

/**
 * @generated from message com.gem.bff.contract.UnpinMessagesResponse
 */
export type UnpinMessagesResponse = Message<'com.gem.bff.contract.UnpinMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UnpinMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UnpinMessagesResponse.
 * Use `create(UnpinMessagesResponseSchema)` to create a new message.
 */
export const UnpinMessagesResponseSchema: GenMessage<UnpinMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 28);

/**
 * @generated from message com.gem.bff.contract.PinMessagesResponse
 */
export type PinMessagesResponse = Message<'com.gem.bff.contract.PinMessagesResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.PinMessagesResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.PinMessagesResponse.
 * Use `create(PinMessagesResponseSchema)` to create a new message.
 */
export const PinMessagesResponseSchema: GenMessage<PinMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 29);

/**
 * @generated from message com.gem.bff.contract.GetPinnedChatsResponse
 */
export type GetPinnedChatsResponse = Message<'com.gem.bff.contract.GetPinnedChatsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetPinnedChatsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserPinnedChats success = 1;
         */
        value: UserPinnedChats;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetPinnedChatsResponse.
 * Use `create(GetPinnedChatsResponseSchema)` to create a new message.
 */
export const GetPinnedChatsResponseSchema: GenMessage<GetPinnedChatsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 30);

/**
 * @generated from message com.gem.bff.contract.PinChatResponse
 */
export type PinChatResponse = Message<'com.gem.bff.contract.PinChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.PinChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.PinChatSuccess success = 1;
         */
        value: PinChatSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.PinnedChannelsLimit pinnedChannelsLimit = 4;
         */
        value: ChatError_PinnedChannelsLimit;
        case: 'pinnedChannelsLimit';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.PinnedGroupsLimit pinnedGroupsLimit = 5;
         */
        value: ChatError_PinnedGroupsLimit;
        case: 'pinnedGroupsLimit';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UnsupportedChatType unsupportedChatType = 6;
         */
        value: ChatError_UnsupportedChatType;
        case: 'unsupportedChatType';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 7;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.PinChatResponse.
 * Use `create(PinChatResponseSchema)` to create a new message.
 */
export const PinChatResponseSchema: GenMessage<PinChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 31);

/**
 * @generated from message com.gem.bff.contract.PinChatSuccess
 */
export type PinChatSuccess = Message<'com.gem.bff.contract.PinChatSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedChat item = 1;
   */
  item?: PersonalizedChat;
};

/**
 * Describes the message com.gem.bff.contract.PinChatSuccess.
 * Use `create(PinChatSuccessSchema)` to create a new message.
 */
export const PinChatSuccessSchema: GenMessage<PinChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 32);

/**
 * @generated from message com.gem.bff.contract.UnpinChatResponse
 */
export type UnpinChatResponse = Message<'com.gem.bff.contract.UnpinChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.UnpinChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UnpinChatSuccess success = 1;
         */
        value: UnpinChatSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UnpinChatResponse.
 * Use `create(UnpinChatResponseSchema)` to create a new message.
 */
export const UnpinChatResponseSchema: GenMessage<UnpinChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 33);

/**
 * @generated from message com.gem.bff.contract.UnpinChatSuccess
 */
export type UnpinChatSuccess = Message<'com.gem.bff.contract.UnpinChatSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedChat item = 1;
   */
  item?: PersonalizedChat;
};

/**
 * Describes the message com.gem.bff.contract.UnpinChatSuccess.
 * Use `create(UnpinChatSuccessSchema)` to create a new message.
 */
export const UnpinChatSuccessSchema: GenMessage<UnpinChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 34);

/**
 * @generated from message com.gem.bff.contract.ClearChatHistoryForMeResponse
 */
export type ClearChatHistoryForMeResponse =
  Message<'com.gem.bff.contract.ClearChatHistoryForMeResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ClearChatHistoryForMeResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ClearChatHistoryForMeResponse.
 * Use `create(ClearChatHistoryForMeResponseSchema)` to create a new message.
 */
export const ClearChatHistoryForMeResponseSchema: GenMessage<ClearChatHistoryForMeResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 35);

/**
 * @generated from message com.gem.bff.contract.ClearChatHistoryForAllResponse
 */
export type ClearChatHistoryForAllResponse =
  Message<'com.gem.bff.contract.ClearChatHistoryForAllResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ClearChatHistoryForAllResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
           */
          value: ChatError_HasNoPermissionsToPerformAction;
          case: 'hasNoPermissionsToPerformAction';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ClearChatHistoryForAllResponse.
 * Use `create(ClearChatHistoryForAllResponseSchema)` to create a new message.
 */
export const ClearChatHistoryForAllResponseSchema: GenMessage<ClearChatHistoryForAllResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 36);

/**
 * @generated from message com.gem.bff.contract.MuteChatResponse
 */
export type MuteChatResponse = Message<'com.gem.bff.contract.MuteChatResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.MuteChatResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.MuteChatResponse.
 * Use `create(MuteChatResponseSchema)` to create a new message.
 */
export const MuteChatResponseSchema: GenMessage<MuteChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 37);

/**
 * @generated from message com.gem.bff.contract.ConfirmReadChatMessagesResponse
 */
export type ConfirmReadChatMessagesResponse =
  Message<'com.gem.bff.contract.ConfirmReadChatMessagesResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.ConfirmReadChatMessagesResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
           */
          value: ChatError_ChatIsUnavailable;
          case: 'chatIsUnavailable';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
           */
          value: ChatError_ChatDoesNotExist;
          case: 'chatDoesNotExist';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.ConfirmReadChatMessagesResponse.
 * Use `create(ConfirmReadChatMessagesResponseSchema)` to create a new message.
 */
export const ConfirmReadChatMessagesResponseSchema: GenMessage<ConfirmReadChatMessagesResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 38);

/**
 * @generated from message com.gem.bff.contract.GetChatUsersResponse
 */
export type GetChatUsersResponse = Message<'com.gem.bff.contract.GetChatUsersResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetChatUsersResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetChatUsersSuccess success = 1;
         */
        value: GetChatUsersSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetChatUsersResponse.
 * Use `create(GetChatUsersResponseSchema)` to create a new message.
 */
export const GetChatUsersResponseSchema: GenMessage<GetChatUsersResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 39);

/**
 * @generated from message com.gem.bff.contract.GetChatUsersSuccess
 */
export type GetChatUsersSuccess = Message<'com.gem.bff.contract.GetChatUsersSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ChatParticipant users = 1;
   */
  users: ChatParticipant[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetChatUsersSuccess.
 * Use `create(GetChatUsersSuccessSchema)` to create a new message.
 */
export const GetChatUsersSuccessSchema: GenMessage<GetChatUsersSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 40);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToChatResponse
 */
export type SearchUsersAddToChatResponse =
  Message<'com.gem.bff.contract.SearchUsersAddToChatResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SearchUsersAddToChatResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SearchUsersAddToChatSuccess success = 1;
           */
          value: SearchUsersAddToChatSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToChatResponse.
 * Use `create(SearchUsersAddToChatResponseSchema)` to create a new message.
 */
export const SearchUsersAddToChatResponseSchema: GenMessage<SearchUsersAddToChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 41);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToChatSuccess
 */
export type SearchUsersAddToChatSuccess =
  Message<'com.gem.bff.contract.SearchUsersAddToChatSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.PersonalizedUser users = 1;
     */
    users: PersonalizedUser[];

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToChatSuccess.
 * Use `create(SearchUsersAddToChatSuccessSchema)` to create a new message.
 */
export const SearchUsersAddToChatSuccessSchema: GenMessage<SearchUsersAddToChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 42);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInChatResponse
 */
export type SearchUsersInChatResponse =
  Message<'com.gem.bff.contract.SearchUsersInChatResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SearchUsersInChatResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SearchUsersInChatSuccess success = 1;
           */
          value: SearchUsersInChatSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersInChatResponse.
 * Use `create(SearchUsersInChatResponseSchema)` to create a new message.
 */
export const SearchUsersInChatResponseSchema: GenMessage<SearchUsersInChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 43);

/**
 * @generated from message com.gem.bff.contract.SearchUsersInChatSuccess
 */
export type SearchUsersInChatSuccess = Message<'com.gem.bff.contract.SearchUsersInChatSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.ChatParticipant users = 1;
   */
  users: ChatParticipant[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.SearchUsersInChatSuccess.
 * Use `create(SearchUsersInChatSuccessSchema)` to create a new message.
 */
export const SearchUsersInChatSuccessSchema: GenMessage<SearchUsersInChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 44);

/**
 * @generated from message com.gem.bff.contract.SearchUsersForMentionResponse
 */
export type SearchUsersForMentionResponse =
  Message<'com.gem.bff.contract.SearchUsersForMentionResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SearchUsersForMentionResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SearchUsersForMentionSuccess success = 1;
           */
          value: SearchUsersForMentionSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersForMentionResponse.
 * Use `create(SearchUsersForMentionResponseSchema)` to create a new message.
 */
export const SearchUsersForMentionResponseSchema: GenMessage<SearchUsersForMentionResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 45);

/**
 * @generated from message com.gem.bff.contract.SearchUsersForMentionSuccess
 */
export type SearchUsersForMentionSuccess =
  Message<'com.gem.bff.contract.SearchUsersForMentionSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.PersonalizedUser users = 1;
     */
    users: PersonalizedUser[];

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersForMentionSuccess.
 * Use `create(SearchUsersForMentionSuccessSchema)` to create a new message.
 */
export const SearchUsersForMentionSuccessSchema: GenMessage<SearchUsersForMentionSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 46);

/**
 * @generated from message com.gem.bff.contract.GetChatEventsSuccess
 */
export type GetChatEventsSuccess = Message<'com.gem.bff.contract.GetChatEventsSuccess'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: repeated com.gem.bff.contract.ChatEvent events = 2;
   */
  events: ChatEvent[];
};

/**
 * Describes the message com.gem.bff.contract.GetChatEventsSuccess.
 * Use `create(GetChatEventsSuccessSchema)` to create a new message.
 */
export const GetChatEventsSuccessSchema: GenMessage<GetChatEventsSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 47);

/**
 * @generated from message com.gem.bff.contract.GetMultipleChatEventsSuccess
 */
export type GetMultipleChatEventsSuccess =
  Message<'com.gem.bff.contract.GetMultipleChatEventsSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.GetChatEventsSuccess chats = 1;
     */
    chats: GetChatEventsSuccess[];
  };

/**
 * Describes the message com.gem.bff.contract.GetMultipleChatEventsSuccess.
 * Use `create(GetMultipleChatEventsSuccessSchema)` to create a new message.
 */
export const GetMultipleChatEventsSuccessSchema: GenMessage<GetMultipleChatEventsSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 48);

/**
 * @generated from message com.gem.bff.contract.GetMultipleChatsEventsResponse
 */
export type GetMultipleChatsEventsResponse =
  Message<'com.gem.bff.contract.GetMultipleChatsEventsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetMultipleChatsEventsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetMultipleChatEventsSuccess success = 1;
           */
          value: GetMultipleChatEventsSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetMultipleChatsEventsResponse.
 * Use `create(GetMultipleChatsEventsResponseSchema)` to create a new message.
 */
export const GetMultipleChatsEventsResponseSchema: GenMessage<GetMultipleChatsEventsResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 49);

/**
 * @generated from message com.gem.bff.contract.GetUsersAddToChatResponse
 */
export type GetUsersAddToChatResponse =
  Message<'com.gem.bff.contract.GetUsersAddToChatResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetUsersAddToChatResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetUsersAddToChatSuccess success = 1;
           */
          value: GetUsersAddToChatSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetUsersAddToChatResponse.
 * Use `create(GetUsersAddToChatResponseSchema)` to create a new message.
 */
export const GetUsersAddToChatResponseSchema: GenMessage<GetUsersAddToChatResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 50);

/**
 * @generated from message com.gem.bff.contract.GetUsersAddToChatSuccess
 */
export type GetUsersAddToChatSuccess = Message<'com.gem.bff.contract.GetUsersAddToChatSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.PersonalizedUser users = 1;
   */
  users: PersonalizedUser[];

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetUsersAddToChatSuccess.
 * Use `create(GetUsersAddToChatSuccessSchema)` to create a new message.
 */
export const GetUsersAddToChatSuccessSchema: GenMessage<GetUsersAddToChatSuccess> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 51);

/**
 * @generated from message com.gem.bff.contract.MarkChatsAsUnreadResponse
 */
export type MarkChatsAsUnreadResponse =
  Message<'com.gem.bff.contract.MarkChatsAsUnreadResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.MarkChatsAsUnreadResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.MarkChatsAsUnreadResponse.
 * Use `create(MarkChatsAsUnreadResponseSchema)` to create a new message.
 */
export const MarkChatsAsUnreadResponseSchema: GenMessage<MarkChatsAsUnreadResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 52);

/**
 * @generated from message com.gem.bff.contract.SetChatMessagesHistoryTtlResponse
 */
export type SetChatMessagesHistoryTtlResponse =
  Message<'com.gem.bff.contract.SetChatMessagesHistoryTtlResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SetChatMessagesHistoryTtlResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
           */
          value: BooleanResponse;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SetChatMessagesHistoryTtlResponse.
 * Use `create(SetChatMessagesHistoryTtlResponseSchema)` to create a new message.
 */
export const SetChatMessagesHistoryTtlResponseSchema: GenMessage<SetChatMessagesHistoryTtlResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 53);

/**
 * @generated from message com.gem.bff.contract.CreateE2eeCommitResponse
 */
export type CreateE2eeCommitResponse = Message<'com.gem.bff.contract.CreateE2eeCommitResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateE2eeCommitResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatIsUnavailable chatIsUnavailable = 2;
         */
        value: ChatError_ChatIsUnavailable;
        case: 'chatIsUnavailable';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.ChatDoesNotExist chatDoesNotExist = 3;
         */
        value: ChatError_ChatDoesNotExist;
        case: 'chatDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.HasNoPermissionsToPerformAction hasNoPermissionsToPerformAction = 4;
         */
        value: ChatError_HasNoPermissionsToPerformAction;
        case: 'hasNoPermissionsToPerformAction';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.UserChatRelationshipDoesNotExist userChatRelationshipDoesNotExist = 5;
         */
        value: ChatError_UserChatRelationshipDoesNotExist;
        case: 'userChatRelationshipDoesNotExist';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitSyncRequired e2eeCommitSyncRequired = 6;
         */
        value: ChatError_E2eeCommitSyncRequired;
        case: 'e2eeCommitSyncRequired';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatError.E2eeCommitResyncRequired e2eeCommitResyncRequired = 7;
         */
        value: ChatError_E2eeCommitResyncRequired;
        case: 'e2eeCommitResyncRequired';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateE2eeCommitResponse.
 * Use `create(CreateE2eeCommitResponseSchema)` to create a new message.
 */
export const CreateE2eeCommitResponseSchema: GenMessage<CreateE2eeCommitResponse> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_responses, 54);
